export default __webpack_public_path__ + "static/media/Rocket_DAO_DD.6f97905b.png";